import { render } from "./CreateAWB.vue?vue&type=template&id=5162ca7f"
import script from "./CreateAWB.vue?vue&type=script&lang=js"
export * from "./CreateAWB.vue?vue&type=script&lang=js"

import "./CreateAWB.vue?vue&type=style&index=0&id=5162ca7f&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__